import { MotiView } from "moti";
import React from "react";

import {
  Box,
  Text,
  Pressable,
} from "@whoosh/design-system/src/components/primitive";

type iTabItemProps = {
  label: String;
  index: number;
  currentIndex: number;
  setIndex: (value: number) => void;
};

export const TabItem = ({
  setIndex,
  index,
  currentIndex,
  label,
}: iTabItemProps) => {
  const active = currentIndex === index;

  return (
    <Pressable
      style={{ borderRadius: 100 }}
      py={2}
      justifyContent="center"
      flexDirection="row"
      onPress={() => setIndex(index)}
      position="relative"
      flexGrow={1}
      flexShrink={1}
    >
      <Text
        maxFontSizeMultiplier={2}
        fontFamily="Inter_400Regular"
        fontSize={12}
        lineHeight={20}
        letterSpacing={0}
        textAlign="center"
        style={{ zIndex: 2 }}
        color={active ? "text-inverse" : "black"}
      >
        {label}
      </Text>
      <MotiView
        pointerEvents="none"
        from={{ opacity: 0 }}
        animate={{ opacity: active ? 1 : 0 }}
        transition={{
          opacity: {
            type: "timing",
            duration: 250,
          },
        }}
        style={{
          width: "100%",
          position: "absolute",
          top: 0,
          bottom: 0,
        }}
      >
        <Box
          position="absolute"
          top={0}
          right={0}
          left={0}
          bottom={0}
          width="100%"
          height="100%"
          style={{ backgroundColor: "#124734", borderRadius: 100 }}
        />
      </MotiView>
    </Pressable>
  );
};
